import { DatePicker as BaseDatePicker, type DatePickerDateType } from '@pba/react-components';
import type { Form } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { Item } from '../item';
import { disabledDate, disabledTime } from './disable';

type InputP = {
  'data-test-id'?: string;
  maximum?: Date;
  minimum?: Date;
} & ComponentProps<typeof BaseDatePicker<DatePickerDateType>>;

type ItemP = {
  hidden?: boolean;
  label?: string;
} & Omit<ComponentProps<typeof Form.Item>, 'children' | 'label'>;

type P = {
  input?: InputP;
  item: ItemP;
};

const defaultInput: InputP = {};

// TODO: This should be in `date-picker` component and probably most should be in components package
export const DatePicker = ({ className, maximum, minimum, ...inputRest }: InputP) => (
  <BaseDatePicker
    allowClear={false}
    className={cn(className, 'ui-date-input')}
    classNames={{ popup: { root: 'ui-date-input-popup' } }}
    disabledDate={disabledDate({ maximum, minimum })}
    disabledTime={disabledTime({ maximum, minimum })}
    needConfirm={false}
    showNow={false}
    {...inputRest}
  />
);

const DateInput = ({ input: { fullWidth = true, ...inputRest } = defaultInput, item }: P) => (
  <Item {...item} label={item.label}>
    <DatePicker fullWidth={fullWidth} {...inputRest} />
  </Item>
);

export default DateInput;

export type DateInputItemProperties = ItemP;
